// extracted by mini-css-extract-plugin
export var heading = "Partners-module--heading--bb8c0";
export var logo = "Partners-module--logo--078c5";
export var logoItem = "Partners-module--logoItem--21540";
export var marquee = "Partners-module--marquee--8e36d";
export var marqueeTrack = "Partners-module--marqueeTrack--75ca3";
export var partners = "Partners-module--partners--113b8";
export var scroll = "Partners-module--scroll--95125";